import { AbstractExpressionEvaluator } from './AbstractExpressionEvaluator';
import { FunctionContext, WorkflowEvaluatorContext } from './FunctionContext';
import { FunctionLibrary } from './FunctionDefinition';
import { WORKFLOW_EVALUATOR_FUNCTIONS } from './functionRegistries';

/**
 * Evaluator for expressions running inside a workflow instance. Has the full context (loan, time,
 * steps, point of contact) and can run every function, including workflow-only ones.
 */
export class WorkflowExpressionEvaluator extends AbstractExpressionEvaluator<FunctionContext> {
  protected readonly functions: FunctionLibrary<FunctionContext> = WORKFLOW_EVALUATOR_FUNCTIONS;

  constructor(ctx: WorkflowEvaluatorContext) {
    super(ctx);
  }
}
